export * from './detail1094.component';



// WEBPACK FOOTER //
// ./src/app/detail1094/index.ts